import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getLinkedMerchantPhone = {
  name: "getLinkedMerchantPhone" as const,
  input: z.null(),
  output: z.object({
    phoneE164: z.string().nullable(),
    smsPreferences: z.object({
      operational: z.boolean(),
      marketing: z.boolean(),
    }),
    stores: z.array(z.object({ teamId: zExt.objectId(), name: z.string() })),
  }),
};
